/* eslint-disable no-restricted-globals */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Paper'
import ActionType from '../../actions/ActionType'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import CircularProgress from '@material-ui/core/CircularProgress'
import Paper from 'components/theme/Paper'
import MaterialTable from 'material-table'
import classNames from 'classnames'
import { deleteGroup } from '../../actions/contacts/groups'
import { REQUEST, SUCCESS } from '../../utils/statusConstants'
import { consumePrediction } from 'actions/predictions'
import language from 'utils/vast-languagepack'
import Icon from '@mdi/react'
import { toggleDeleteDialog } from 'actions/view'
import { mdiPlus } from '@mdi/js'

const mapStateToProps = (state) => ({
  groups: state.contacts.groupsByID,
  loadStatus: state.loadStatus.groups,
  createContactGroup: state.predictions.createContactGroup
    ? state.predictions.createContactGroup
    : null,
})

const mapDispatchToProps = (dispatch) => {
  const { Contacts } = ActionType
  const dispatchType = (type, payload) => (dispatch) =>
    dispatch({ type, payload })
  return bindActionCreators(
    {
      deleteGroup,
      openCreateGroupDialog: (id, name) =>
        dispatchType(Contacts.OPEN_RENAME_GROUP_DIALOG, { id, name }),
      clickGroup: (name) => dispatchType(Contacts.CLICK_GROUP, name),
      consumePrediction,
      toggleDeleteDialog,
    },
    dispatch,
  )
}

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
})

class GroupsPage extends Component {
  componentDidMount() {
    const { groups, loadStatus } = this.props

    if (!Object.keys(groups).length && loadStatus === SUCCESS) {
      this.handleCreateClick()
    } else {
      this.handlePrediction()
    }
  }

  componentDidUpdate() {
    const { groups, loadStatus } = this.props

    if (!Object.keys(groups).length && loadStatus === SUCCESS) {
      this.handleCreateClick()
    } else {
      this.handlePrediction()
    }
  }

  handleDeleteGroup = (event, groupID) => {
    event.preventDefault()
    this.props.deleteGroup(groupID)
  }

  handleCreateClick = () => {
    this.props.openCreateGroupDialog('new', '')
  }

  handlePrediction = () => {
    const {
      createContactGroup,
      openCreateGroupDialog,
      consumePrediction,
    } = this.props

    if (
      createContactGroup &&
      createContactGroup.entities.length &&
      createContactGroup.entities[0].type === 'GROUP'
    ) {
      openCreateGroupDialog('new', createContactGroup.entities[0].entity)
      consumePrediction('createContactGroup')
    }
  }

  render() {
    const { groups, classes, loadStatus } = this.props
    return (
      <div>
        {Object.values(groups).length ? (
          <MaterialTable
            columns={[
              { title: language.groups.groupName, field: 'name' },
              {
                title: language.groups.contactCount,
                field: 'contact_count',
                defaultSort: 'desc',
              },
            ]}
            data={Object.values(groups)}
            title={language.groups.groupHeading}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 25, 50, 100],
              actionsColumnIndex: -1,
            }}
            actions={[
              {
                icon: 'edit',
                tooltip: language.groups.toolTips.editGroup,
                onClick: (event, rowData) =>
                  this.props.history.push(`/contactgroups/${rowData.id}`),
              },
              (rowData) => ({
                icon: 'delete',
                tooltip: language.groups.toolTips.deleteGroup,
                onClick: (event, rowData) =>
                  // this.handleDeleteGroup(event, rowData.id),
                  this.props.toggleDeleteDialog({
                    ...rowData,
                    entityType: 'contactgroup',
                  }),
              }),
            ]}
            components={{
              Container: (props) => (
                <Paper>
                  <div {...props} />
                </Paper>
              ),
            }}
          />
        ) : loadStatus === REQUEST || loadStatus === null ? (
          <CircularProgress className={classes.progress} color="secondary" />
        ) : (
          <div
            style={{
              textAlign: 'center',
              padding: '13px',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              border: 'solid 1px #adadad',
              borderRadius: '35px',
            }}
          >
            <div style={{ marginTop: '40px' }}>{language.groups.noResults}</div>
            <div
              style={{
                textAlign: 'center',
                fontSize: '20px',
                backgroundColor: '#014c94',
                color: '#ffffff',
                padding: '1%',
                maxWidth: '300px',
                borderRadius: '20px',
                margin: '40px auto 40px auto',
                border: '1px solid black',
                cursor: 'pointer',
                boxShadow:
                  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
              }}
              onClick={this.handleCreateClick}
            >
              <Icon path={mdiPlus} size={4} color="white" />
              <br />
              {language.groups.toolTips.createGroup}
            </div>
          </div>
        )}
        <Tooltip title={language.groups.toolTips.createGroup} placement="left">
          <Button
            color="secondary"
            variant="fab"
            aria-label="Add"
            className={classNames(classes.button, classes.floatingActionButton)}
            onClick={this.handleCreateClick}
          >
            <AddIcon />
          </Button>
        </Tooltip>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(GroupsPage))
